import { IAuthToken } from '../models/auth';
import { IApiService } from '../services/api_service';
import config from '../services/config';

export const outsideParty = (siteApi: IApiService, getToken: () => IAuthToken) => ({
  photoUrl: (id: number): string => {
    return `${config.api.url}/visitor/photo/${id}?token=${getToken().accessToken}&r=${new Date()}`;
  }
});
